import * as React from "react";
import {
    Navbar,
    Container,
    Button,
} from 'reactstrap';
import Request from '../../common/Request';
import _ from 'underscore';
import AsyncLock from 'async-lock';

import CarouselImage from './CarouselImage';
import DialogBase from "../Base/DialogBase";

import {googleMapKey} from  '../../variables/apikeys';
export let google;


let lock = new AsyncLock();
let scriptLoaded = false;

const PIN_COLOR = {
    FIXED_PIN: 'purple', // 固定ピン（編集不可）
    REGISTERED_PIN: 'red', // パラメータdataで指定されるすでに登録済みのPIN
    MANUAL_PIN: 'blue', // 地図領域をクリックして新たにつけるPIN
    EMPHASIS_PIN: 'yellow',　// 強調するPIN
};
const PIN_TYPE = {
    FIXED_PIN: 0,
    REGISTERED_PIN: 1,
    MANUAL_PIN: 2
};
export default class GoogleMap extends React.Component {
    mapRef = React.createRef();
    map;
    searchManager;
    dynamic_pininfo = null; // 画面クリックでつけたピン　center_pinで指定されたピン
    tooltip;
    tooltipTemplate = '<div style="background-color:white;height:100px;width:130px;padding:5px;text-align:center"><b>{title}</b><br/><img src="{img}" style="height:70px;width:auto;"/></div>';

    constructor(props) {
        super(props);

        this.state = {
            googleMapKey: googleMapKey,
            address: '',
            editable: this.props.editable ? true : false,
            editself: this.props.editself ? true : false, // ダイアログ表示で自前の編集保存機能を有効にする
            left_side_enable: this.props.left_side_enable,
            left_side_open: false,
            data: this.props.data ? this.props.data : [], // 位置情報を含む配列データ
            selectingInfo: { pin_type: PIN_TYPE.MANUAL_PIN }, // 選択中の駐車場情報
            emphasisIds: [], // 強調表示するID一覧
            center_pin: this.props.center_pin ? this.props.center_pin : 2, // 0:ピンを立てない 1: Fixedピンを立てる（固定編集不可） 2: 動的PINを立てる
            center_processed: false, // centerの処理は値が変わっても初回だけやるためのフラグ（初回空っぽで2回目以降にデータが来た場合　2回めだけ処理する）
            sessionCheckInterval:undefined
        };

        this.editConfirmDialog = React.createRef();
        this.editDialog = React.createRef();
        this.script = undefined
        this.setEmphasisIds = this.setEmphasisIds.bind(this);
        this.setAddress = this.setAddress.bind(this);
        this.onClickMap = this.onClickMap.bind(this);
        this.onRightClickMap = this.onRightClickMap.bind(this);
        this.onClickPin = this.onClickPin.bind(this);
        this.onMouseOverPin = this.onMouseOverPin.bind(this);
        this.onMouseOutPin = this.onMouseOutPin.bind(this);
        this.onDragPin = this.onDragPin.bind(this);
        this.onDragStartPin = this.onDragStartPin.bind(this);
        this.onDragEndPin = this.onDragEndPin.bind(this);
        this.leftSideOpen = this.leftSideOpen.bind(this);
        this.leftSideClose = this.leftSideClose.bind(this);
        this.removePin = this.removePin.bind(this);
        this.addPin = this.addPin.bind(this);
        this.closeTooltip = this.closeTooltip.bind(this);
        this.selectWithId = this.selectWithId.bind(this);
        this.initPins = this.initPins.bind(this);
        this.handleChangeFiles = this.handleChangeFiles.bind(this);

        this.editConfirmDialogHandleClickPositive = this.editConfirmDialogHandleClickPositive.bind(this);
        this.editConfirmDialogHandleClickNegative = this.editConfirmDialogHandleClickNegative.bind(this);
        this.editDialogHandleClickPositive = this.editDialogHandleClickPositive.bind(this);
        this.editDialogHandleClickNegative = this.editDialogHandleClickNegative.bind(this);
    }

    componentDidMount() {
        if (window.GooglemapRefreshIsNeeded) {
            window.location.reload()
        }
        this.loadGoogleApi().then(() => {
            if(this.props.center.latitude > 0 && this.props.center.longitude > 0){
                this.initMap(this.props.center.latitude,this.props.center.longitude);
            }else{
                this.initMap();
            }
        });
    }
    componentWillUnmount(){
        clearTimeout(this.state.sessionCheckInterval)
        this.setState({
            sessionCheckInterval:undefined
        })
    }
    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props) === JSON.stringify(prevProps))
            return;
        if(!this.map){
            return;            
        }
        this.updateCenterPin();
        this.setState({ data: this.props.data, emphasisIds: [] }, () => { this.initPins() });
    }

    // 初期PINの配置や　データ変更に伴うPINの再配置
    initPins() {
        if(!this.map)
            return;
        if(this.props.center.latitude > 0 && this.props.center.longitude > 0){
            if (this.dynamic_pininfo)
                this.removePin(this.dynamic_pininfo);
            const location = {lat:this.props.center.latitude,lng:this.props.center.longitude}
            this.dynamic_pininfo = this.addPin(location);
        }
    }

    updateCenterPin() {
        if(!this.state.center_processed){

            if(this.props.center.latitude > 0 && this.props.center.longitude > 0){
                if (this.dynamic_pininfo)
                    this.removePin(this.dynamic_pininfo);

                // this.map.setCenter(this.props.center);
                this.initMap(this.props.center.latitude,this.props.center.longitude);
                this.setState({center_processed: true});
            }      
        }
    }

    // 強調するデータのIDを設定
    setEmphasisIds(ids) {

    }

    selectWithId(id) {

    }

    leftSideOpen() {

    }

    leftSideClose() {
 
    }

    /**
     * 住所からピンを打つ
     */
    setAddress(address) {
        this.setState({
            address
        })
        if(!address)
            return

        this.geocodeQuery(address);
    }

    removePin(pininfo) {
        if (pininfo == null){
            return ;
        }
        
        if (Array.isArray(pininfo.handlers)) {
            _.each(pininfo.handlers, (item) => {
                google.maps.event.removeListener(item);
            });
        }
        pininfo.handlers = [];
        pininfo.metadata = [];
        pininfo.pin.setMap(null);
    }

    addPin(location, metadata = {}, pin_type = PIN_TYPE.MANUAL_PIN) {
        let color = PIN_COLOR.MANUAL_PIN;
        switch (pin_type) {
            case PIN_TYPE.FIXED_PIN:
                color = PIN_COLOR.FIXED_PIN;
                break;
            case PIN_TYPE.REGISTERED_PIN:
                color = PIN_COLOR.REGISTERED_PIN;
                break;
            case PIN_TYPE.MANUAL_PIN:
                color = PIN_COLOR.MANUAL_PIN;
                break;
        }

        var markerOptions = {
            position:  new google.maps.LatLng(location.lat, location.lng),
            color: color, 
            draggable: this.state.editable && pin_type !== PIN_TYPE.FIXED_PIN ,
            // icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/parking_lot_maps.png",
            map: this.map
        };

        var pin = new google.maps.Marker(markerOptions);
        metadata = Object.assign(metadata, {
            pin_type: pin_type,
            latitude: location.lat,
            longitude: location.lng,
        });


        let handlers = [];
        if (this.state.editable && pin_type !== PIN_TYPE.FIXED_PIN) {
            handlers.push(google.maps.event.addListener(pin, 'click', this.onClickPin));
            handlers.push(google.maps.event.addListener(pin, 'mouseover', this.onMouseOverPin));
            handlers.push(google.maps.event.addListener(pin, 'mouseout', this.onMouseOutPin));
            handlers.push(google.maps.event.addListener(pin, 'drag', this.onDragPin));
            handlers.push(google.maps.event.addListener(pin, 'dragend', this.onDragEndPin));
            handlers.push(google.maps.event.addListener(pin, 'dragstart', this.onDragStartPin));
        }

        return { pin: pin, handlers: handlers, metadata: metadata };
    }

    onClickMap(e) {
        if (this.dynamic_pininfo)
            this.removePin(this.dynamic_pininfo);
            console.log(this.dynamic_pininfo);

        const location = {lat:e.latLng.lat(),lng:e.latLng.lng()}
        this.dynamic_pininfo = this.addPin(location);
        this.setState({ selectingInfo: this.dynamic_pininfo.metadata, center_processed: true }, () => {
            this.props.onLocationChange && this.props.onLocationChange(e.latLng.lat(), e.latLng.lng());
        });


    }

    onRightClickMap(e) {

    }

    onClickPin(e) {

    }

    onMouseOverPin(e) {

    }

    onMouseOutPin(e) {

    }

    onDragPin(e) {

    }

    onDragStartPin(e) {

    }

    onDragEndPin(e) {
        console.log('drag end');

        this.props.onLocationChange && this.props.onLocationChange(e.latLng.lat(),e.latLng.lng() );

        this.state.editself && this.editConfirmDialog.current.show();
    }

    openTooltip(pin) {

    }

    closeTooltip() {
        this.tooltip.setOptions({
            visible: false
        });
    }

    // ファイル選択ダイアログでファイルを選択したときに呼ばれる
    handleChangeFiles(e) {
        if (e.target.files.length <= 0) {
            return;
        }

        let selectingInfo = this.state.selectingInfo;
        // if(selectingInfo.image_files) {
        //     selectingInfo.image_files.push(e.target.files);
        // } else {
        selectingInfo.image_files = e.target.files;
        // }
        this.setState({ selectingInfo: selectingInfo });
    }

    // dialog actions
    editConfirmDialogHandleClickPositive() {
        this.editDialog.current.show();
    }

    editConfirmDialogHandleClickNegative() {
        // 選択したPINが新規位置だったら　青PINを消す
        if (this.state.selectingInfo.pin_type === PIN_TYPE.MANUAL_PIN) {
            if (this.dynamic_pininfo)
                this.removePin(this.dynamic_pininfo);
            this.setState({ selectingInfo: {} });
        }
    }

    editDialogHandleClickPositive() {
    }

    editDialogHandleClickNegative() {
        // 選択したPINが新規位置だったら　青PINを消す
        if (this.state.selectingInfo.pin_type === PIN_TYPE.MANUAL_PIN) {
            if (this.dynamic_pininfo)
                this.removePin(this.dynamic_pininfo);
            this.setState({ selectingInfo: {} });
        }
    }


    loadGoogleApi() {
        const callbackName = "googleAPIReady";
        let url = `https://maps.googleapis.com/maps/api/js?key=${this.state.googleMapKey}&callback=${callbackName}`;

        return new Promise((resolve, reject) => {
            lock.acquire('loadGoogleApi', () => {
                if (scriptLoaded) {
                    var id = setInterval(() => {
                        if (google) {
                            clearInterval(id);
                            resolve();
                        }
                    }, 1000);
                    return;
                }
                this.script = document.createElement("script");
                this.script.type = "text/javascript";
                this.script.async = true;
                this.script.defer = true;
                this.script.src = url;
                window.googleAPIReady = () => {
                    google = window.google;
                    this.setState({sessionCheckInterval : setTimeout(
                        ()=>{
                            this.searchManager=undefined
                            this.mapRef.current.innerHTML=""
                            scriptLoaded = false
                            this.script=undefined
                            this.loadGoogleApi().then(() => {
                                if(this.props.center.latitude > 0 && this.props.center.longitude > 0){
                                    this.updateCenterPin();
                                }else{
                                    this.initMap();
                                }
                                                              
                            });
                        },59*60*1000)
                    })
                    resolve();
                };
                this.script.onError = (error) => {
                    reject(error);
                };
                this.mapRef.current.appendChild(this.script);
                window.GooglemapRefreshIsNeeded = true
                scriptLoaded = true
            });
        });
    }

    render() {
        let image_urls = [];
        this.state.selectingInfo.parking_picture_url_thumbnail && image_urls.push(this.state.selectingInfo.parking_picture_url_thumbnail);
        return (
            <>
                <div style={{ width: "100%", height: "100%", position: "relative", zIndex:0 }}>
                    <div ref={this.mapRef} className="map" style={{ zIndex: "500" }} />
                    {this.state.left_side_open &&
                        <div style={{ position: "absolute", top: 0, left: 0, bottom: 0, zIndex: "501", width: "300px", background: "white" }}>
                            <Navbar color="primary" className="navbar-dark">
                                <Container>
                                    <span className="navbar-text">{this.state.selectingInfo.parking_name_contract}</span>
                                    <Button size="sm" onClick={() => { this.leftSideClose() }}>閉じる</Button>
                                </Container>
                            </Navbar>
                            <CarouselImage image_urls={image_urls} image_files={this.state.selectingInfo.image_files} height={"200px"} />
                            {/* <CardImg top src={this.state.selectingInfo.parking_picture_url_thumbnail} alt="" style={{ "width": "100%" }} /> */}
                            <div>
                                駐車場ID: {this.state.selectingInfo.parking_id}<br />
                                {this.props.getAdditionalView ? this.props.getAdditionalView(this.state.selectingInfo.parking_id) : ''}<br />
                                緯度: {this.state.selectingInfo.latitude}<br />
                                経度: {this.state.selectingInfo.longitude}<br />
                                住所: {this.state.selectingInfo.parking_address_contract}<br />
                                その他　必要な情報<br />
                            </div>

                        </div>
                    }
                </div>
                <EditConfirmDialog ref={this.editConfirmDialog} class="edit-confirm-dialog" handleClickPositive={this.editConfirmDialogHandleClickPositive} handleClickNegative={this.editConfirmDialogHandleClickNegative} />
                <EditDialog ref={this.editDialog} class="edit-dialog" handleClickPositive={this.editDialogHandleClickPositive} handleClickNegative={this.editDialogHandleClickNegative} />
            </>
        );
    }

    initMap(lat=35.6731706,lng=139.7386161) {
        let mapOptions = { center: {lat: lat,lng: lng} };

        if (this.props.aerial) {
            mapOptions.mapTypeId = google.maps.MapTypeId.SATELLITE;
        }

        mapOptions.zoom = this.props.zoom ? this.props.zoom : 18;
        mapOptions.disableScrollWheelZoom = true;
        // https://lab.syncer.jp/Web/API/Google_Maps/JavaScript/MapTypeStyle/
        mapOptions.styles =  [
                                { featureType: 'poi',stylers: [{ visibility: 'off' }]},
                                { featureType: 'landscape.man_made',stylers: [{ visibility: 'simplified' }]}
                            ];

        this.map = new google.maps.Map(this.mapRef.current, mapOptions);
        if (this.state.editable) {
           google.maps.event.addListener(this.map, 'click', this.onClickMap);
           google.maps.event.addListener(this.map, 'rightclick', this.onRightClickMap);
        }

        var set = google.maps.InfoWindow.prototype.set;
        google.maps.InfoWindow.prototype.set = function(key, val) {
            if (key === "map") {
                if (! this.get("noSuppress")) {
                    return;
                }
            }
            set.apply(this, arguments);
        }

        this.initPins();
    }

    geocodeQuery(query) {

        const geoUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${query}&key=${this.state.googleMapKey}&components=country:JP`

        Request.get(geoUrl,{}, res => {
            if (res && res.data && res.data.results && res.data.results.length > 0) {

                const loctaion = res.data.results[0].geometry.location;
                const {lat,lng} = loctaion;

                this.initMap(lat,lng);

                this.props.onLocationChange && this.props.onLocationChange(lat,lng);
                this.removePin(this.dynamic_pininfo);
                this.dynamic_pininfo = this.addPin(loctaion); 

            }
          }, (err) => {
            console.log('GoogleMapApi errorCallback :', err)
          }, () => {}, false, false, false
        )

    }
}

class EditConfirmDialog extends DialogBase {
    constructor(props) {
        super(props);

        Object.assign(this.state, {
            title: '編集確認',
            size: 'sm'
        });
    }

    bodyContent() {
        return (
            <>
                編集しますか？
            </>
        );
    }
}

class EditDialog extends DialogBase {
    constructor(props) {
        super(props);

        Object.assign(this.state, {
            title: '編集',
            size: 'lg',
            positive_label: '登録',
            negative_label: 'キャンセル'
        });
    }

    bodyContent() {
        return (
            <>
                画像選択<br />
                緯度経度表示<br />
                住所入力<br />
                その他　編集したい項目
            </>
        );
    }
}